import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Link from '@mui/material/Link';
import Divider from '@mui/material/Divider';
import Logo from '../components/Images/logo.png'
const nav = [
  { label: 'Home', to: '/' },
  { label: 'About', to: '/about' },
  { label: 'Services', to: '/services' },
  { label: 'Case Studies', to: '/case-studies' },
  { label: 'Blog', to: '/blog' },
  { label: 'FAQ', to: '/faq' },
  { label: 'Contact', to: '/contact' },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen(!open);

  return (
    <AppBar position="sticky" color="primary" elevation={0}>
      <Toolbar>
        <Box component={RouterLink} to="/" sx={{ display:'flex', alignItems:'center', textDecoration:'none', color:'#fff', mr:2 }}>
          <img src={Logo} alt="Bloomington Restoration Services" width="100px"  />
        </Box>
        <Box sx={{ flexGrow:1, display:{ xs:'none', md:'flex' }, gap:1 }}>
          {nav.map(item => (
            <Button key={item.to} component={RouterLink} to={item.to} sx={{ color:'#fff' }}>
              {item.label}
            </Button>
          ))}
        </Box>
        <Box sx={{ display:{ xs:'none', md:'flex' }, gap:1 }}>
        <Button
  component={RouterLink}
  to="/book"
  variant="contained"
  sx={{
    backgroundColor: '#d32f2f', 
    color: '#fff',
    fontWeight: 500,
    '&:hover': {
      backgroundColor: '#b71c1c', 
    },
  }}
>
  Book Emergency Service
</Button>

          <Button component={Link} href="tel:+18125550123" variant="outlined" color="inherit">Call (812) 555-0123</Button>
        </Box>
        <Box sx={{ display:{ xs:'flex', md:'none' }, ml:'auto' }}>
          <IconButton color="inherit" onClick={toggle}><MenuIcon /></IconButton>
        </Box>
      </Toolbar>
      <Drawer anchor="right" open={open} onClose={toggle}>
        <Box sx={{ width: 280, p:2 }} role="presentation" onClick={toggle}>
          <Box sx={{ display:'flex', alignItems:'center', gap:1, mb:1 }}>
            <img src="/assets/logo-dark.svg" width="36" height="36" alt="logo" />
            <Typography variant="h6">BRS</Typography>
          </Box>
          <Divider sx={{ mb:1 }} />
          <List>
            {nav.map(n => (
              <ListItem key={n.to} disablePadding>
                <ListItemButton component={RouterLink} to={n.to}>
                  <ListItemText primary={n.label} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
          <Box sx={{ p:1 }}>
            <Button fullWidth component={RouterLink} to="/book" variant="contained">Book Emergency</Button>
          </Box>
          <Box sx={{ p:1 }}>
            <Button fullWidth component={Link} href="tel:+18125550123" variant="outlined">Call (812) 555-0123</Button>
          </Box>
        </Box>
      </Drawer>
    </AppBar>
  );
}
